window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages.Safra = window.FazendaRP.Pages.Safra || {};

window.FazendaRP.Pages.Safra.Dashboard = {
    init: async function () {
        const container = document.getElementById('view-dashboard');
        if (!container) return;

        container.innerHTML = `
            <!-- KPI Cards V4 -->
            <div style="display:grid; grid-template-columns:repeat(4, 1fr); gap:20px; margin-bottom:25px;">
                <div class="kpi-card-safra" style="border-left: 4px solid #15803d;">
                    <div class="kpi-label-safra">Colheita Total</div>
                    <div class="kpi-value-safra" id="kpi-total">... <span style="font-size:1rem;color:#64748b;">sc</span></div>
                    <div class="kpi-sub-safra" id="kpi-total-sub">Carregando...</div>
                </div>
                <div class="kpi-card-safra" style="border-left: 4px solid #3b82f6;">
                    <div class="kpi-label-safra">Produtividade Média</div>
                    <div class="kpi-value-safra" id="kpi-prod">... <span style="font-size:1rem;color:#64748b;">sc/ha</span></div>
                    <div class="kpi-sub-safra" id="kpi-prod-sub"><i class="fas fa-seedling" style="color:#10b981"></i> Calculando...</div>
                </div>
                <div class="kpi-card-safra" style="border-left: 4px solid #f59e0b;">
                    <div class="kpi-label-safra">Custo Médio</div>
                    <div class="kpi-value-safra">R$ ... <span style="font-size:1rem;color:#64748b;">/sc</span></div>
                    <div class="kpi-sub-safra">Módulo em Desenvolvimento</div>
                </div>
                <div class="kpi-card-safra" style="border-left: 4px solid #10b981;">
                    <div class="kpi-label-safra">Lucro Estimado</div>
                    <div class="kpi-value-safra">R$ ...</div>
                    <div class="kpi-sub-safra">Baseado em Contratos</div>
                </div>
            </div>

            <!-- Charts Row -->
            <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 20px; margin-bottom:20px;">
                <div class="card-safra">
                    <h3 style="margin:0 0 20px 0; color:#1e293b; font-weight:600; display:flex; align-items:center; gap:10px;">
                        <i class="fas fa-chart-bar" style="color:#15803d;"></i> Produtividade por Variedade (sc/ha)
                    </h3>
                    <div style="height: 300px;">
                        <canvas id="chartProd"></canvas>
                    </div>
                </div>
                <div class="card-safra">
                    <h3 style="margin:0 0 20px 0; color:#1e293b; font-weight:600; display:flex; align-items:center; gap:10px;">
                        <i class="fas fa-chart-pie" style="color:#15803d;"></i> Destino da Safra
                    </h3>
                    <div style="height: 300px; position:relative;">
                        <canvas id="chartDestino"></canvas>
                    </div>
                </div>
            </div>

            <!-- Storage Table -->
            <div id="storage-card-container" class="card-safra">
                <h3 style="margin:0 0 15px 0; color:#1e293b; font-weight:600; display:flex; align-items:center; gap:10px;">
                    <i class="fas fa-warehouse" style="color:#15803d;"></i> Estoque em Armazéns
                </h3>
                <div id="storage-list"></div>
            </div>
        `;

        this.injectStyles();
        await this.loadMetrics();
    },

    injectStyles: function () {
        if (document.getElementById('safra-dash-v4-styles')) return;
        const style = document.createElement('style');
        style.id = 'safra-dash-v4-styles';
        style.innerHTML = `
            .kpi-card-safra {
                background: white; padding: 20px; border-radius: 12px; 
                box-shadow: 0 1px 3px rgba(0,0,0,0.08); position: relative; overflow: hidden;
            }
            .kpi-label-safra {
                font-size: 0.75rem; color: #64748b; text-transform: uppercase; 
                letter-spacing: 0.5px; font-weight: 600;
            }
            .kpi-value-safra {
                font-size: 1.8rem; font-weight: 700; color: #0f172a; margin: 8px 0;
            }
            .kpi-sub-safra {
                font-size: 0.85rem; color: #94a3b8;
            }
            .card-safra {
                background: white; border-radius: 12px; padding: 20px; 
                box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb;
            }
        `;
        document.head.appendChild(style);
    },

    loadMetrics: async function () {
        // 1. Fetch Areas
        const { data: areasData } = await window.FazendaRP.supabase.from('safras_areas').select('*');
        const areaMap = {};
        let totalArea = 0;
        if (areasData) {
            areasData.forEach(a => {
                areaMap[a.variedade] = a.area_ha || 0;
                totalArea += a.area_ha || 0;
            });
        }

        // 2. Fetch Harvest
        const { data: colheitas, error } = await window.FazendaRP.supabase
            .from('safras_colheitas')
            .select('peso_liquido_final, variedade, destino_tipo, local_armazem');

        if (error) {
            console.error("Erro dashboard safra:", error);
            return;
        }

        if (!colheitas) return;

        // KPI Calculations
        let totalKg = 0;
        const varietyStats = {};
        const destStats = { 'Contrato': 0, 'Armazem': 0, 'Spot': 0 };

        colheitas.forEach(c => {
            const peso = c.peso_liquido_final || 0;
            totalKg += peso;

            if (c.variedade) {
                if (!varietyStats[c.variedade]) varietyStats[c.variedade] = 0;
                varietyStats[c.variedade] += peso;
            }

            const dest = c.destino_tipo === 'Contrato' ? 'Contrato' : (c.destino_tipo === 'Spot' ? 'Spot' : 'Armazem');
            if (destStats[dest] !== undefined) destStats[dest] += peso;
        });

        const totalSc = totalKg / 60;
        document.getElementById('kpi-total').innerHTML = `${totalSc.toLocaleString('pt-BR', { maximumFractionDigits: 0 })} <span style="font-size:1rem;color:#64748b;">sc</span>`;
        document.getElementById('kpi-total-sub').innerText = `${(totalKg / 1000).toFixed(1)} toneladas`;

        // Productivity
        let avgProd = 0;
        if (totalArea > 0) {
            avgProd = totalSc / totalArea;
            document.getElementById('kpi-prod').innerHTML = `${avgProd.toLocaleString('pt-BR', { maximumFractionDigits: 1 })} <span style="font-size:1rem;color:#64748b;">sc/ha</span>`;
            document.getElementById('kpi-prod-sub').innerHTML = `<i class="fas fa-check-circle" style="color:#10b981"></i> Área Plantada: ${totalArea} ha`;
        } else {
            document.getElementById('kpi-prod').innerHTML = `0,0 <span style="font-size:1rem;color:#64748b;">sc/ha</span>`;
            document.getElementById('kpi-prod-sub').innerText = "Configure as Áreas";
        }

        // Render Charts
        this.renderCharts(varietyStats, destStats, areaMap);
        this.renderStorageTable(colheitas);
    },

    renderCharts: function (varietyStats, destStats, areaMap) {
        // Productivity Chart
        const labels = Object.keys(varietyStats);
        const dataProd = labels.map(v => {
            const kg = varietyStats[v];
            const sc = kg / 60;
            const ha = areaMap[v] || 0;
            return ha > 0 ? (sc / ha) : 0;
        });

        const ctxProd = document.getElementById('chartProd').getContext('2d');
        if (window.safraChart1) window.safraChart1.destroy();
        window.safraChart1 = new Chart(ctxProd, {
            type: 'bar',
            data: {
                labels: labels.length ? labels : ['Sem Dados'],
                datasets: [{
                    label: 'Produtividade (sc/ha)',
                    data: dataProd.length ? dataProd : [0],
                    backgroundColor: ['#15803d', '#16a34a', '#22c55e', '#4ade80'],
                    borderRadius: 6
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                return context.parsed.y.toFixed(1) + ' sc/ha';
                            }
                        }
                    }
                },
                scales: {
                    y: { beginAtZero: true, grid: { color: '#f1f5f9' } },
                    x: { grid: { display: false } }
                }
            }
        });

        // Destination Chart
        const ctxDest = document.getElementById('chartDestino').getContext('2d');
        if (window.safraChart2) window.safraChart2.destroy();
        window.safraChart2 = new Chart(ctxDest, {
            type: 'doughnut',
            data: {
                labels: ['Contrato', 'Armazém', 'Spot'],
                datasets: [{
                    data: [destStats['Contrato'] / 60, destStats['Armazem'] / 60, destStats['Spot'] / 60],
                    backgroundColor: ['#f59e0b', '#3b82f6', '#94a3b8'],
                    borderWidth: 2,
                    borderColor: '#fff'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '65%',
                plugins: {
                    legend: { position: 'bottom' }
                }
            }
        });
    },

    renderStorageTable: function (colheitas) {
        const stats = {};
        colheitas.forEach(c => {
            if (c.destino_tipo === 'Armazem' || c.destino_tipo === 'Armazém') {
                const local = c.local_armazem || 'Não Informado';
                if (!stats[local]) stats[local] = 0;
                stats[local] += c.peso_liquido_final || 0;
            }
        });

        const list = document.getElementById('storage-list');
        if (Object.keys(stats).length === 0) {
            list.innerHTML = '<p style="color:#64748b; font-size:0.9rem;">Nenhuma carga enviada para armazenamento.</p>';
            return;
        }

        let html = '<table style="width:100%; border-collapse:collapse;">';
        html += '<tr style="text-align:left; color:#64748b; font-size:0.85rem; border-bottom:2px solid #e5e7eb;"><th style="padding:10px;">Local</th><th style="padding:10px; text-align:right;">Sacas (sc)</th><th style="padding:10px; text-align:right;">Toneladas</th></tr>';

        for (const [local, kg] of Object.entries(stats)) {
            html += `
                <tr style="border-bottom:1px solid #f1f5f9;">
                    <td style="padding:12px 10px; font-weight:500;">${local}</td>
                    <td style="padding:12px 10px; text-align:right; font-weight:600; color:#15803d;">${(kg / 60).toLocaleString('pt-BR', { maximumFractionDigits: 0 })}</td>
                    <td style="padding:12px 10px; text-align:right; color:#64748b;">${(kg / 1000).toFixed(1)} t</td>
                </tr>
            `;
        }
        html += '</table>';
        list.innerHTML = html;
    }
};
